import { render, staticRenderFns } from "./AlfabankUpgradePayment.vue?vue&type=template&id=76db78f2&scoped=true&"
import script from "./AlfabankUpgradePayment.vue?vue&type=script&lang=js&"
export * from "./AlfabankUpgradePayment.vue?vue&type=script&lang=js&"
import style0 from "./AlfabankUpgradePayment.vue?vue&type=style&index=0&id=76db78f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76db78f2",
  null
  
)

/* custom blocks */
import block0 from "./AlfabankUpgradePayment.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./AlfabankUpgradePayment.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCheckbox,VDialog})
